import type { MxpV2ErrorCode } from './mxp365-v2.types';

export class MxpNavigationError extends Error {
  readonly code: MxpV2ErrorCode;
  readonly requestId?: string;

  constructor(code: MxpV2ErrorCode, message: string, requestId?: string) {
    super(message);
    this.name = 'MxpNavigationError';
    this.code = code;
    this.requestId = requestId;
  }
}
